import { render } from "./VXQRScanner.vue?vue&type=template&id=245c7e3b&scoped=true"
import script from "./VXQRScanner.vue?vue&type=script&lang=js"
export * from "./VXQRScanner.vue?vue&type=script&lang=js"

import "./VXQRScanner.vue?vue&type=style&index=0&id=245c7e3b&scoped=true&lang=css"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245c7e3b"]])

export default __exports__